/**
 * Product branding for the frontend, mirroring Ruby's BrandingHelper.
 *
 * Anything rendering the product name in copy should read it from here rather
 * than spelling it out.
 *
 * Values are kept in step with Branding::CAREERMINDS — change them in both
 * places.
 */
export const CAREERMINDS_BRAND_NAME = 'Careerminds'

const CAREERMINDS = {
  name: CAREERMINDS_BRAND_NAME,
  siteUrl: 'https://www.careerminds.com',
  supportEmail: 'support@careerminds.com',
}

const brand = () => CAREERMINDS

export const brandName = (): string => brand().name

export const brandSiteUrl = (): string => brand().siteUrl

export const brandSupportEmail = (): string => brand().supportEmail

/** Marketing site link carrying the public-framework attribution params. */
export const brandMarketingUrl = (campaign?: string): string => {
  const params = new URLSearchParams({
    utm_source: 'public_framework',
    utm_medium: 'web',
  })
  if (campaign) params.set('utm_campaign', campaign)

  return `${brandSiteUrl()}?${params.toString()}`
}
